import type { AdminAcquisitionFunnelResponse, AdminAcquisitionGroupBy } from '@kopechka/contracts';
import { callAdminApi, type ApiClientOptions, type ApiResult } from './client.js';

/**
 * D-265 — GET /admin/acquisition/funnel (financial:review).
 * Days are UTC calendar days (YYYY-MM-DD); `to` is inclusive.
 */
export interface AcquisitionFunnelParams {
  readonly from: string;
  readonly to: string;
  readonly groupBy: AdminAcquisitionGroupBy;
}

export function getAcquisitionFunnel(
  options: ApiClientOptions,
  params: AcquisitionFunnelParams,
): Promise<ApiResult<AdminAcquisitionFunnelResponse>> {
  const query = new URLSearchParams({ from: params.from, to: params.to, groupBy: params.groupBy });
  return callAdminApi(options, { method: 'GET', path: `/admin/acquisition/funnel?${query.toString()}` });
}
